import { z } from "zod";

export const GibsUserSession = z.object({
    isLoggedIn: z.boolean(),
    userName: z.string(),
    lastName: z.string().nullable().optional()
});